export const DEPARTMENT_MODAL_TABS = {
  DETAILS: "details",
  MEMBERS: "members",
  CHANNELS: "channels",
};

export const DEPARTMENT_MODAL_MODES = {
  CREATE: "CREATE",
  EDIT: "EDIT",
};

export const departmentInitialState = {
  name: "",
  bannerMessage: "",
  profileImage: "",
  isArchived: false,
  users: [],
};

export const DEPARTMENT_STATUSES = {
  ALL: "ALL",
  ACTIVE: "ACTIVE",
  ARCHIVED: "ARCHIVED",
};

export const CREATE_OR_UPDATE_MODAL_STATES = {
  CREATE_OR_EDIT: "CREATE_OR_EDIT",
  ADD_MEMBERS: "ADD_MEMBERS",
  ARCHIVE_CHANNEL: "ARCHIVE_CHANNEL",
};
